  // services/tables.js
  import { getSubdomain, fetchWithAuth } from "../helpers";
  import { API_PASSWORD } from "../config";




  export const fetchAllTables = async () => {
    const subdomain = getSubdomain();
    const branchId = localStorage.getItem("branch_id"); // ✅ جلب رقم الفرع من التخزين

    if (!branchId) {
      throw new Error("❌ لا يمكن العثور على رقم الفرع (branch_id)");
    }

    const apiUrl = `https://${subdomain}.restocash.app/api/sales/screen/tabls/${branchId}`;

    console.log("📡 إرسال طلب إلى:", apiUrl);

    const response = await fetchWithAuth(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }, true); // ✅ نحتاج التوكن في الهيدر

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في جلب الطاولات:", data);
      throw new Error(data?.message || "❌ فشل في جلب الطاولات.");
    }

    console.log("✅ الطاولات:", data.data);
    return data.data || [];
  };



  export const fetchDeliveryOrders = async () => {
    const subdomain = getSubdomain();
    const branchId = localStorage.getItem("branch_id");

    if (!branchId) throw new Error("❌ لا يمكن العثور على رقم الفرع (branch_id)");

    const apiUrl = `https://${subdomain}.restocash.app/api/sales/screen/delivery/${branchId}`;

    console.log("📡 إرسال طلب إلى:", apiUrl);

    const response = await fetchWithAuth(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }, true); // ✅ نرسل التوكن

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في جلب طلبات الدليفري:", data);
      throw new Error(data?.message || "❌ فشل في جلب طلبات الدليفري.");
    }

    console.log("✅ الطلبات:", data);
    return data || [];
  };




  export const fetchTakeawayOrders = async () => {
    const subdomain = getSubdomain();
    const branchId = localStorage.getItem("branch_id");

    if (!branchId) throw new Error("❌ لا يمكن العثور على رقم الفرع (branch_id)");

    const apiUrl = `https://${subdomain}.restocash.app/api/sales/screen/takeaway/${branchId}`;
    console.log("📡 إرسال طلب إلى:", apiUrl);

    const response = await fetchWithAuth(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }, true); // ✅ إرسال التوكن

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في جلب طلبات التيك أواي:", data);
      throw new Error(data?.message || "❌ فشل في جلب طلبات التيك أواي.");
    }

    console.log("✅ الطلبات:", data);
    return data || [];
  };


  export const createOrder = async (orderData) => {
    const subdomain = getSubdomain();
    const rootId = localStorage.getItem("branch_id");
    const orderType = localStorage.getItem("current_component") || "tables";

    if (!rootId) {
      throw new Error("❌ لم يتم العثور على branch_id في localStorage");
    }

    const apiUrl = `https://${subdomain}.restocash.app/api/create/order`;

    console.log("📡 إرسال طلب إنشاء أوردر إلى:", apiUrl);

    // تجهيز البيانات على شكل FormData
    const formData = new FormData();
    Object.entries({
      ...orderData,
      root_id: rootId,
      order_type: orderType
    }).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // إرسال باستخدام fetchWithAuth (مع isFormData = true)
    const response = await fetchWithAuth(
      apiUrl,
      {
        method: "POST",
        body: formData,
      },
      true // isFormData = true لتجنب تعيين Content-Type يدويًا
    );

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في إنشاء الأوردر:", data);
      throw new Error(data?.message || "❌ فشل في إنشاء الأوردر.");
    }

    console.log("✅ الأوردر تم إنشاؤه:", data);
    return data;
  };



  // export const addItemToOrder = async ({ order_id, items }) => {
  //   const subdomain = getSubdomain();

  //   const apiUrl = `https://${subdomain}.restocash.app/api/add/new/item/to/order`;

  //   const formData = new FormData();
  //   formData.append("order_id", order_id);

  //   items.forEach((item, index) => {
  //     formData.append(`items[${index}][product_id]`, item.product_id);
  //     formData.append(`items[${index}][quantity]`, item.quantity);
  //     formData.append(`items[${index}][price]`, item.quantity);
  //     formData.append(`items[${index}][note]`, item.note || "");
      
  //   });

  //   const response = await fetchWithAuth(
  //     apiUrl,
  //     {
  //       method: "POST",
  //       body: formData,
  //     },
  //     true // ✅ isFormData = true
  //   );

  //   const data = await response.json();

  //   if (!response.ok) {
  //     console.error("❌ فشل في إضافة العناصر:", data);
  //     throw new Error(data?.message || "حدث خطأ أثناء إضافة العناصر.");
  //   }

  //   console.log("✅ تم إضافة العناصر:", data);
  //   return data;
  // };
  export const addItemToOrder = async ({ order_id, items }) => {
    const subdomain = getSubdomain();

    const apiUrl = `https://${subdomain}.restocash.app/api/add/new/item/to/order`;

    const formData = new FormData();
    formData.append("order_id", order_id);

    items.forEach((item, index) => {
      formData.append(`items[${index}][product_id]`, item.product_id);
      formData.append(`items[${index}][quantity]`, item.quantity);
      formData.append(`items[${index}][price]`, item.price); // استخدم price الصحيح لو توفر
      formData.append(`items[${index}][note]`, item.note || "");

      // ✅ أرسل الحالة فقط إذا تم تحديدها
      if (item.status) {
        formData.append(`items[${index}][status]`, item.status);
      }
    });

    const response = await fetchWithAuth(
      apiUrl,
      {
        method: "POST",
        body: formData,
      },
      true // ✅ isFormData = true
    );

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في إضافة العناصر:", data);
      throw new Error(data?.message || "حدث خطأ أثناء إضافة العناصر.");
    }

    console.log("✅ تم إضافة العناصر:", data);
    return data;
  };






  export const fetchProducts = async () => {
    const subdomain = getSubdomain();
    const branchId = localStorage.getItem("branch_id");

    if (!branchId) {
      throw new Error("❌ لا يوجد branch_id في localStorage");
    }

    const url = `https://${subdomain}.restocash.app/api/sales/screens/products/${branchId}`;

    try {
      const response = await fetchWithAuth(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        console.error("❌ فشل في جلب المنتجات:", data);
        throw new Error(data?.message || "فشل في جلب المنتجات");
      }

      console.log("✅ المنتجات:", data.data);
      return data.data;
    } catch (error) {
      console.error("❌ خطأ أثناء جلب المنتجات:", error);
      throw error;
    }
  };


  export const fetchOrderDetails = async (orderId) => {
    const subdomain = getSubdomain();
    const apiUrl = `https://${subdomain}.restocash.app/api/get/order/${orderId}`;

    console.log("📡 طلب تفاصيل الأوردر:", apiUrl);

    const response = await fetchWithAuth(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في جلب تفاصيل الأوردر:", data);
      throw new Error(data?.message || "فشل في جلب تفاصيل الأوردر.");
    }

    console.log("✅ تفاصيل الأوردر:", data);
    return data;
  };



  export const createInvoice = async (invoiceData) => {
    const subdomain = getSubdomain();
    const apiUrl = `https://${subdomain}.restocash.app/api/create/invoice?api_password=Project102$`;

    console.log("📡 إرسال طلب إنشاء فاتورة إلى:", apiUrl);

    const response = await fetchWithAuth(
      apiUrl,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(invoiceData),
      },
      true // ✅ نرسل التوكن في الهيدر
    );

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في إنشاء الفاتورة:", data);
      throw new Error(data?.message || "❌ فشل في إنشاء الفاتورة.");
    }

    console.log("✅ الفاتورة تم إنشاؤها:", data);
    return data;
  };




  export const updateOrder = async (orderId, payload) => {
    const subdomain = getSubdomain();
    const rootId = localStorage.getItem("branch_id");
    const orderType = localStorage.getItem("current_component");

    if (!rootId || !orderType) {
      throw new Error("❌ لم يتم العثور على root_id أو order_type في localStorage");
    }

    const apiUrl = `https://${subdomain}.restocash.app/api/update/order`;

    console.log("📡 إرسال تعديل أوردر إلى:", apiUrl);

    const formData = new FormData();

    formData.append("order_id", orderId);
    formData.append("root_id", rootId);
    formData.append("order_type", orderType);

    if (payload.customer_name) formData.append("customer_name", payload.customer_name);
    if (payload.customer_phone1) formData.append("customer_phone1", payload.customer_phone1);
    if (payload.customer_phone2) formData.append("customer_phone2", payload.customer_phone2);
    if (payload.customer_phone3) formData.append("customer_phone3", payload.customer_phone3);
    if (payload.customer_address1) formData.append("customer_address1", payload.customer_address1);
    if (payload.customer_address2) formData.append("customer_address2", payload.customer_address2);
    if (payload.customer_id) formData.append("customer_id", payload.customer_id);

    if (payload.table_id) formData.append("table_id", payload.table_id);
    if (payload.captain_order_id) formData.append("captain_order_id", payload.captain_order_id);
    if (payload.delivery_id) formData.append("delivery_id", payload.delivery_id);

    const response = await fetchWithAuth(apiUrl, {
      method: "POST",
      body: formData,
    }, true);

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في تعديل الأوردر:", data);
      throw new Error(data?.message || "❌ حدث خطأ أثناء تعديل الأوردر.");
    }

    console.log("✅ تم تعديل الأوردر:", data);
    return data;
  };


  export const deleteOrder = async (orderId) => {
    const subdomain = getSubdomain();
    const apiUrl = `https://${subdomain}.restocash.app/api/delete/order/${orderId}?api_password=Project102$_`;

    console.log("🗑️ حذف الطلب:", apiUrl);

    const response = await fetchWithAuth(apiUrl, {
      method: "GET",
    }, true); // ✅ نرسل التوكن

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في حذف الطلب:", data);
      throw new Error(data?.message || "❌ حدث خطأ أثناء حذف الطلب.");
    }

    console.log("✅ تم حذف الطلب:", data);
    return data;
  };






  export const deleteItemFromOrder = async (itemId) => {
    const subdomain = getSubdomain();
    const apiUrl = `https://${subdomain}.restocash.app/api/delete/item/${itemId}?api_password=Project102$_`;

    console.log("🗑️ حذف عنصر من الأوردر:", apiUrl);

    const response = await fetchWithAuth(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }, true); // ✅ إرسال التوكن

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في حذف العنصر:", data);
      throw new Error(data?.message || "❌ فشل في حذف العنصر من الأوردر.");
    }

    console.log("✅ تم حذف العنصر:", data);
    return data;
  };






  // export const updateOrderItem = async (itemData) => {
  //   const subdomain = getSubdomain();
  //   const apiUrl = `https://${subdomain}.restocash.app/api/update/order/item/?api_password=Project102$_`;

  //   console.log("📝 تعديل بيانات عنصر في الأوردر:", apiUrl);

  //   const formData = new FormData();
  //   formData.append("id", itemData.id); // ✅ مهم جدًا
  //   formData.append("quantity", itemData.quantity);
  //   formData.append("price", itemData.price);
  //   if (itemData.note) formData.append("note", itemData.note);

  //   const response = await fetchWithAuth(apiUrl, {
  //     method: "POST",
  //     body: formData,
  //   }, true); // ✅ التوكن

  //   const data = await response.json();

  //   if (!response.ok) {
  //     console.error("❌ فشل في تعديل بيانات العنصر:", data);
  //     throw new Error(data?.message || "❌ حدث خطأ أثناء تعديل بيانات العنصر.");
  //   }

  //   console.log("✅ تم تعديل العنصر بنجاح:", data);
  //   return data;
  // };
  export const updateOrderItem = async (itemData) => {
    const subdomain = getSubdomain();
    const apiUrl = `https://${subdomain}.restocash.app/api/update/order/item?api_password=Project102$_`;

    const formData = new FormData();
    formData.append("id", itemData.id);           // 👈 order_item.id
    formData.append("quantity", itemData.quantity);
    if (itemData.price !== undefined) formData.append("price", itemData.price);
    if (itemData.note !== undefined) formData.append("note", itemData.note);

    const response = await fetchWithAuth(apiUrl, { method: "POST", body: formData }, true);

    let data = {};
    let rawText = "";
    try {
      rawText = await response.text();
      data = JSON.parse(rawText);
    } catch (e) {
      console.warn("⚠️ الرد مش JSON:", e, rawText);
    }

    // ✅ مرونة في التعامل مع الرد
    if (data?.message && data.message.includes("تم تعديل")) {
      console.log("✅ تعديل ناجح:", data);
      return data;
    }

    console.error("❌ فشل في تعديل بيانات العنصر:", data, rawText);
    throw new Error(data?.message || rawText || "❌ فشل في تعديل بيانات العنصر");
  };




export const fetchCustomers = async () => {
  const subdomain = window.location.hostname.split('.')[0];
  const apiUrl = `https://${subdomain}.restocash.app/api/customers?api_password=Project102$_`;

  const response = await fetch(apiUrl, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.message || "❌ فشل في تحميل العملاء");
  }

  return data.data;
};




// ✅ جلب الكباتن المتاحين
export const fetchCaptains = async () => {
  const subdomain = window.location.hostname.split(".")[0];
  const rootId = localStorage.getItem("branch_id");
  const token = localStorage.getItem("token");
  const apiPassword = "Project102$_";

  const url = `https://${subdomain}.restocash.app/api/captain/order/data/${rootId}?api_password=${apiPassword}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  const text = await response.text();

  try {
    const data = JSON.parse(text);
    if (!response.ok) throw new Error(data?.message || "❌ فشل تحميل الكباتن");
    return data.data;
  } catch {
    throw new Error("❌ فشل في تحميل الكباتن: البيانات غير صالحة");
  }
};

export const fetchDeliveries = async () => {
  const subdomain = window.location.hostname.split(".")[0];
  const rootId = localStorage.getItem("branch_id");
  const token = localStorage.getItem("token");
  const apiPassword = "Project102$_";

  const url = `https://${subdomain}.restocash.app/api/delivery/data/${rootId}?api_password=${apiPassword}`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  const text = await response.text();

  try {
    const data = JSON.parse(text);
    if (!response.ok) throw new Error(data?.message || "❌ فشل تحميل الدليفري");
    return data.data;
  } catch {
    throw new Error("❌ فشل في تحميل الدليفري: البيانات غير صالحة");
  }
};

export const moveItemToOtherOrder = async ({ item_id, source_order_id, target_table, quantity }) => {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/move/item/to/onther/order?api_password=Project102$_`;

  const formData = new FormData();
  formData.append("item_id", item_id);
  formData.append("source_order_id", source_order_id);
  formData.append("target_table", target_table);
  formData.append("quantity", quantity);

  const response = await fetchWithAuth(url, {
    method: "POST",
    body: formData,
  }, true);

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في نقل الصنف:", data);
    throw new Error(data?.message || "❌ فشل في نقل الصنف.");
  }

  console.log("✅ تم نقل الصنف:", data);
  return data;
};



export async function divideTableOrder(orderId, selectedItems) {
  const subdomain = window.location.hostname.split(".")[0];
  
  const url = `https://${subdomain}.restocash.app/api/divide/table/orders/${orderId}?api_password=Project102$_`;

  const body = {
    
    order_id: orderId,
    sub_orders: [{ items: selectedItems }],
    
  };

  const res = await fetchWithAuth(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const result = await res.json();

  if (!res.ok) {
    throw new Error(result.message || "❌ فشل في تقسيم الطلب");
  }

  return result;
}


// جلب بيانات خزن المستخدم في تقفيل الفاتورة 
export const fetchBanks = async () => {
  const subdomain = window.location.hostname.split(".")[0];
const rootId = localStorage.getItem("branch_id"); // ✅ بدل root_id بـ branch_id

  if (!rootId) throw new Error("❌ لم يتم العثور على root_id في localStorage");

  const apiUrl = `https://${subdomain}.restocash.app/api/root/user/banks/${rootId}?api_password=Project102$_`;

  const response = await fetch(apiUrl, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.message || "❌ فشل في تحميل الخزن");
  }

  return data.data;
};


export const createOffer = async (offerData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/offer?api_password=Project102$_`;

  console.log("📡 إرسال عرض جديد إلى:", apiUrl);

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(offerData),
  }, true); // ✅ نرسل التوكن في الهيدر

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في إضافة العرض:", data);
    throw new Error(data?.message || "❌ فشل في إضافة العرض.");
  }

  console.log("✅ تم إضافة العرض:", data);
  return data;
};


// جلب جميع العروض
export const getAllOffers = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/get/offers?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, { method: "GET" }, false);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.message || "❌ فشل في تحميل العروض");
  }

  return data.data; // ✅ رجّع فقط المصفوفة هنا
};




export const fetchPendingReservations = async () => {
  const subdomain = window.location.hostname.split(".")[0];
  const rootId = localStorage.getItem("branch_id"); // أو root_id حسب مشروعك
  const token = localStorage.getItem("token");

  if (!rootId) {
    throw new Error("❌ لم يتم العثور على root_id في localStorage");
  }

  const url = `https://${subdomain}.restocash.app/api/pending/reservations/${rootId}?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في جلب الحجوزات:", data);
    throw new Error(data?.message || "❌ فشل في تحميل الحجوزات.");
  }

  console.log("✅ الحجوزات:", data.data);
  return data.data; // ✅ نرجع فقط مصفوفة الحجوزات
};

export const createReservation = async (payload) => {
  const subdomain = window.location.hostname.split(".")[0];
  const apiUrl = `https://${subdomain}.restocash.app/api/create/reservation?api_password=Project102$_`;

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في إنشاء الحجز:", data);
    throw new Error(data?.message || "❌ فشل في إنشاء الحجز");
  }

  console.log("✅ تم إنشاء الحجز:", data);
  return data;
};
// جلب الحجوزات المعلقة لطاولة محددة



// تعديل بيانات العرض
export const updateOffer = async (offerData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/update/offer?api_password=Project102$_`;

  console.log("📝 إرسال تعديل عرض إلى:", apiUrl);

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...offerData,
      itmes: offerData.items, // ✅ تصحيح التسمية حسب ما يطلبه الـ backend
    }),
  }, true); // ✅ نرسل التوكن في الهيدر

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في تعديل العرض:", data);
    throw new Error(data?.message || "❌ فشل في تعديل العرض.");
  }

  console.log("✅ تم تعديل العرض:", data);
  return data;
};



export const linkOfferToBranch = async (offer_id, root_id) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/add/offer/root?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      offer_id,
      "root id": root_id,
      root_id: root_id
    }),
  }, true);

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في ربط العرض:", data);
    throw new Error(data?.message || "❌ فشل في ربط العرض بالفرع.");
  }

  return data;
};

export const unlinkOfferFromBranch = async (offer_id, root_id) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/remove/offer/root?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      offer_id,
      root_id,
    }),
  }, true); // ✅ requires token

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في حذف الربط:", data);
    throw new Error(data?.message || "❌ فشل في إزالة العرض من الفرع.");
  }

  return data;
};

export const changeOfferStatus = async (offerId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/change/offer/status/${offerId}?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
  }, true); // ✅ نرسل التوكن

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في تغيير حالة العرض:", data);
    throw new Error(data?.message || "❌ فشل في إيقاف تشغيل العرض.");
  }

  return data;
};

export const fetchOfferById = async (offerId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/get/offer/${offerId}?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }, true); // ✅ التوكن مطلوب

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في جلب بيانات العرض:", data);
    throw new Error(data?.message || "❌ فشل في جلب بيانات العرض.");
  }

  return data;
};


export const fetchActiveOffers = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/active/offers/1?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  }, true); // ✅ نرسل التوكن

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في جلب العروض النشطة:", data);
    throw new Error(data?.message || "❌ فشل في تحميل العروض.");
  }

  return data.data;
};



// export const addOfferToOrder = async ({ offer_id, order_id , offer_quantity }) => {
//   const subdomain = getSubdomain();
//   const apiUrl = `https://${subdomain}.restocash.app/api/add/offer/to/order?api_password=Project102$_`;

//   const formData = new FormData();
//   formData.append("offer_id", offer_id);
//   formData.append("order_id", order_id);
//   formData.append("offer_quantity", offer_quantity);



//   const response = await fetchWithAuth(apiUrl, {
//     method: "POST",
//     body: formData,
//   }, true);

//   const data = await response.json();

//   if (!response.ok) {
//     console.error("❌ فشل في ربط العرض بالطلب:", data);
//     throw new Error(data?.message || "❌ فشل في تنفيذ العملية.");
//   }

//   console.log("✅ تم ربط العرض بالطلب:", data);
//   return data;
// };
export const addOfferToOrder = async ({ offer_id, order_id, offer_quantity }) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/add/offer/to/order?api_password=Project102$_`;

  const formData = new FormData();
  formData.append("offer_id", Number(offer_id));
  formData.append("order_id", Number(order_id));
  formData.append("offer_quantity", Number(offer_quantity || 1)); // ✅ افتراضي 1

  console.log("📤 offer payload:", {
    offer_id,
    order_id,
    offer_quantity,
    types: {
      offer_id: typeof offer_id,
      order_id: typeof order_id,
      offer_quantity: typeof offer_quantity,
    },
  });

  const response = await fetchWithAuth(
    apiUrl,
    { method: "POST", body: formData },
    true
  );

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في ربط العرض بالطلب:", data);
    throw new Error(data?.message || "❌ فشل في تنفيذ العملية.");
  }

  return data;
};

export const fetchOfferDetailsById = async (offerId) => {
  const subdomain = window.location.hostname.split(".")[0];
  const apiUrl = `https://${subdomain}.restocash.app/api/get/offer/${offerId}?api_password=Project102$_`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في جلب تفاصيل العرض:", data);
    throw new Error(data?.message || "❌ فشل في تحميل بيانات العرض.");
  }

  return data.data; // ✅ نرجع فقط كائن العرض نفسه
};

export const deleteReservation = async (id) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/delete/reservation/${id}?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
  }, true); // ✅ نرسل التوكن

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في حذف الحجز:", data);
    throw new Error(data?.message || "❌ فشل في حذف الحجز.");
  }

  console.log("✅ تم حذف الحجز:", data);
  return data;
};

export const updateReservation = async (id, payload) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/update/reservation/${id}?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }, true); // ✅ نرسل التوكن

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في تعديل بيانات الحجز:", data);
    throw new Error(data?.message || "❌ فشل في تعديل بيانات الحجز.");
  }

  console.log("✅ تم تعديل بيانات الحجز:", data);
  return data;
};


export const confirmReservation = async (id) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/confirmed/reservation/${id}?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
  }, true); // ✅ التوكن مطلوب

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في تأكيد الحجز:", data);
    throw new Error(data.message || "❌ فشل في تأكيد الحجز.");
  }

  console.log("✅ تم تأكيد الحجز:", data);
  return data;
};

export const cancelReservation = async (id) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/cancel/reservation/${id}?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
  }, true); // ✅ التوكن مطلوب

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في إلغاء الحجز:", data);
    throw new Error(data?.message || "❌ فشل في إلغاء الحجز.");
  }

  console.log("✅ تم إلغاء الحجز:", data);
  return data;
};

export const changeOrderItemStatus = async (itemId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/change/order/items/status/${itemId}?api_password=Project102$_`;

  console.log("📡 تغيير حالة العنصر:", apiUrl);

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
  }, true); // ✅ نرسل التوكن

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في تعديل حالة العنصر:", data);
    throw new Error(data?.message || "❌ فشل في تعديل حالة العنصر.");
  }

  console.log("✅ تم تعديل العنصر بنجاح:", data);
  return data;
};


// جلب بيانات البنوك للإيداع
export const fetchBanksForDeposit = async () => {
  const subdomain = getSubdomain();
  const apiPassword = "Project102$_";
  const apiUrl = `https://${subdomain}.restocash.app/api/get/banks/for/deposit?api_password=${apiPassword}`;

  console.log("📡 جلب بيانات البنوك للإيداع:", apiUrl);

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في جلب بيانات البنوك للإيداع:", data);
    throw new Error(data?.message || "❌ فشل في جلب بيانات البنوك للإيداع.");
  }

  console.log("✅ بيانات البنوك للإيداع:", data.banks);
  return data.banks;
};

export const withdraw = async (payload) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/make/withdrawal`;

  console.log("📡 إرسال طلب سحب الأموال إلى:", apiUrl);

  // ✅ قراءة branch_id من localStorage وإضافته للـ payload باسم root_id
  const branchId = localStorage.getItem("branch_id");
  if (branchId) {
    payload.root_id = branchId;
  }

  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true);

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في عملية السحب:", data);
    throw new Error(data?.message || "❌ فشل في عملية السحب.");
  }

  console.log("✅ تم السحب بنجاح:", data);
  return data;
};

export const deposit = async (payload) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/make/deposit`;

  console.log("📡 إرسال طلب إيداع الأموال إلى:", apiUrl);

  // ✅ قراءة branch_id من localStorage وإضافته للـ payload
  const branchId = localStorage.getItem("branch_id");
  if (branchId) {
    payload.root_id = branchId; // أو payload.branch_id = branchId حسب المطلوب من السيرفر
  }

  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true);

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في عملية الإيداع:", data);
    throw new Error(data?.message || "❌ فشل في عملية الإيداع.");
  }

  console.log("✅ تم الإيداع بنجاح:", data);
  return data;
};

export const transfer = async (payload) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/transfer/mony`;

  console.log("📡 إرسال طلب ترحيل الأموال إلى:", apiUrl);

  // ✅ قراءة branch_id من localStorage وإضافته للـ payload
  const branchId = localStorage.getItem("branch_id");
  if (branchId) {
    payload.root_id = branchId; // أو payload.branch_id = branchId حسب المطلوب من السيرفر
  } else {
    console.warn("⚠️ لم يتم العثور على branch_id في localStorage. قد تفشل العملية إذا كان هذا الحقل مطلوبًا.");
  }

  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true);

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في عملية الترحيل:", data);
    throw new Error(data?.message || "❌ فشل في عملية الترحيل.");
  }

  console.log("✅ تم الترحيل بنجاح:", data);
  return data;
};

